import React from "react";
import { Card, Grid, Skeleton } from "@mantine/core";

export default function ExpertSmallCardSkeleton({
  dictionary,
  expert,
  ...props
}) {
  return (
    <Card
      padding={"lg"}
      style={{ borderRadius: "12px" }}
      withBorder
      className='m-2'>
      <Grid align='center'>
        <Grid.Col span={12}>
          <div className='flex flex-col'>
            <div className='flex justify-between items-center'>
              <div className='flex flex-wrap '>
                <Skeleton height={24} width={80} radius='sm' mt={4} mx={4} />
              </div>
              <Skeleton height={28} mb={6} mx={4} width={28} radius='sm' />
            </div>
            <div className='flex flex-col mt-[15px]'>
              <div className='flex'>
                <div className='flex items-center text-primary w-full'>
                  <Skeleton height={18} mb={6} mx={4} width={100} radius='xl' />
                </div>
                <div className='flex items-center text-primary  w-full'>
                  <Skeleton height={18} mb={6} mx={4} width={100} radius='xl' />
                </div>
              </div>

              <div className='flex items-center text-primary'>
                <Skeleton height={18} mb={6} mx={4} width={100} radius='xl' />
              </div>
            </div>
            <div className='flex items-center mt-[15px]'>
              <Skeleton height={60} circle />
              <div className='flex flex-col ms-[12px]'>
                <Skeleton height={24} mb={6} width={130} radius='xl' />
                <Skeleton height={17} mt={6} width={150} radius='xl' />{" "}
              </div>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
